"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckClippingLocalComponentParameters = void 0;
exports.CheckClippingLocalComponentParameters = [
    {
        id: 'recording',
        label: 'Audio File',
        description: 'Audio file to check for clipping',
        type: 'string',
        paramType: 'FILE',
        required: true,
    },
    {
        id: 'audio_clipped',
        label: 'Audio Clipped',
        description: 'Is the audio clipped? Output of the audio clipping checker',
        type: 'output',
        paramType: 'BOOLEAN',
        required: true,
    },
];
//# sourceMappingURL=CheckAudioClippingLocal.js.map